import { Integration, IntegrationType } from 'admin-panel/constants';

export interface IntegrationDisplayInfo {
  systemName: string;
  vendor: string;
  website: string;
  logo?: string;
  type: IntegrationType;
}

export const INTEGRATION_DISPLAY_INFO: Record<
  Integration,
  IntegrationDisplayInfo
> = {
  [Integration.Apaleo]: {
    systemName: 'Apaleo Open PMS',
    vendor: 'Apaleo',
    website: 'https://apaleo.com/open-pms',
    logo: '/images/integrations/apaleo.png',
    type: IntegrationType.PMS,
  },
  [Integration.Asa]: {
    systemName: 'ASA Hotel',
    vendor: 'ASA',
    website: 'https://www.asahotel.com/en/software/asa-hotel-software',
    logo: '/images/integrations/asa.png',
    type: IntegrationType.PMS,
  },
  [Integration.Duve]: {
    systemName: 'Duve',
    vendor: 'Duve',
    website: 'https://duve.com',
    logo: '/images/integrations/duve.png',
    type: IntegrationType.PMS,
  },
  [Integration.Fias]: {
    systemName: 'FIAS',
    vendor: 'Oracle',
    website:
      'https://docs.oracle.com/cd/E94145_01/docs/Oracle%20Hospitality-IFC8-FIAS%20Interface%20Specs%202.20.23.pdf',
    logo: '/images/integrations/oracle.png',
    type: IntegrationType.PMS,
  },
  [Integration.Guestline]: {
    systemName: 'Guestline',
    vendor: 'Guestline',
    website:
      'https://www.guestline.com/products/property-management/property-management-system',
    logo: '/images/integrations/guestline.png',
    type: IntegrationType.PMS,
  },
  [Integration.Hotelkit]: {
    systemName: 'Hotelkit',
    vendor: 'Hotelkit',
    website: 'https://hotelkit.net',
    logo: '/images/integrations/hotelkit.png',
    type: IntegrationType.SRS,
  },
  [Integration.Hotsoft]: {
    systemName: 'HotSoft PMS',
    vendor: 'Hoist Group',
    website:
      'https://www.hoistgroup.com/products/property-management/hotsoft-pms',
    logo: '/images/integrations/hotsoft.png',
    type: IntegrationType.PMS,
  },
  [Integration.Infor]: {
    systemName: 'Infor HMS',
    vendor: 'Infor',
    website: 'https://www.infor.com/products/hms',
    logo: '/images/integrations/infor.png',
    type: IntegrationType.PMS,
  },
  [Integration.Maxxton]: {
    systemName: 'Maxxton',
    vendor: 'Maxxton',
    website: 'https://www.maxxton.com',
    logo: '/images/integrations/maxxton.png',
    type: IntegrationType.PMS,
  },
  [Integration.Mews]: {
    systemName: 'Mews',
    vendor: 'Mews',
    website: 'https://www.mews.com/en',
    logo: '/images/integrations/mews.png',
    type: IntegrationType.PMS,
  },
  [Integration.Ohip]: {
    systemName: 'OHIP',
    vendor: 'Oracle',
    website: 'https://www.oracle.com/hospitality/integration-platform/',
    logo: '/images/integrations/oracle.png',
    type: IntegrationType.PMS,
  },
  [Integration.Protel]: {
    systemName: 'protel.I/O',
    vendor: 'Protel',
    website: 'https://www.protel.io',
    logo: '/images/integrations/protel.png',
    type: IntegrationType.PMS,
  },
  [Integration.Shiji]: {
    systemName: 'Shiji',
    vendor: 'Shiji',
    website: 'https://docs.shijigroup.com/',
    logo: '/images/integrations/shiji.png',
    type: IntegrationType.PMS,
  },
  [Integration.Sihot]: {
    systemName: 'SIHOT.PMS',
    vendor: 'SIHOT',
    website: 'https://sihot.com/en/products/sihot-pms',
    logo: '/images/integrations/sihot.png',
    type: IntegrationType.PMS,
  },
  [Integration.SimphonyGen1]: {
    systemName: 'Simphony (Generation 1) BETA',
    vendor: 'Oracle',
    website:
      'https://www.oracle.com/industries/food-beverage/restaurant-pos-systems/simphony-pos',
    logo: '/images/integrations/oracle.png',
    type: IntegrationType.POS,
  },
  [Integration.SimphonyGen2]: {
    systemName: 'Simphony (Generation 2)',
    vendor: 'Oracle',
    website:
      'https://www.oracle.com/industries/food-beverage/restaurant-pos-systems/simphony-pos',
    logo: '/images/integrations/oracle.png',
    type: IntegrationType.POS,
  },
  [Integration.Stayntouch]: {
    systemName: 'Stayntouch Hotel PMS',
    vendor: 'StayNTouch',
    website: 'https://www.stayntouch.com/cloud-pms',
    logo: '/images/integrations/stayntouch.png',
    type: IntegrationType.PMS,
  },
  [Integration.Suite8]: {
    systemName: 'Oracle Hospitality Suite 8',
    vendor: 'Oracle',
    website:
      'https://www.oracle.com/industries/hospitality/products/suite8-property.html',
    logo: '/images/integrations/oracle-suite8.png',
    type: IntegrationType.PMS,
  },
  [Integration.Unifocus]: {
    systemName: 'Unifocus',
    vendor: 'Unifocus',
    website: 'https://www.unifocus.com/',
    logo: '/images/integrations/unifocus.png',
    type: IntegrationType.SRS,
  },
};

export const displayInfoFor = (
  serviceName: string
): IntegrationDisplayInfo | undefined =>
  Object.hasOwn(INTEGRATION_DISPLAY_INFO, serviceName)
    ? INTEGRATION_DISPLAY_INFO[serviceName as Integration]
    : undefined;
